import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import AutoRetrieverDeviceOverviewContextProvider from "./context/AutoRetrieverDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {AUTO_RETRIEVER} from "../../util/RouteConstants";

class AutoRetrieverDevicePage extends Component {
    render() {
        return (
            <Column>
                <AutoRetrieverDeviceOverviewContextProvider>
                    <TabLayout routes={AUTO_RETRIEVER} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={AUTO_RETRIEVER}/>
                </AutoRetrieverDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AutoRetrieverDevicePage


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/AutoRetrieverDevicePage.js